import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";
import { driftTypeLabelKey, driftTypeTone } from "./drift-alerts";

interface DriftTypeBadgeProps {
  readonly driftType: string;
  readonly testId?: string;
}

const TONE_CLASS: Record<ReturnType<typeof driftTypeTone>, string> = {
  critical: "bg-destructive/10 text-destructive",
  warning: "bg-amber-100 text-amber-800",
};

export function DriftTypeBadge({ driftType, testId }: DriftTypeBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 font-sans text-xs font-medium",
        TONE_CLASS[driftTypeTone(driftType)],
      )}
    >
      {t(driftTypeLabelKey(driftType))}
    </span>
  );
}
